import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api, { apiError } from "@/lib/api";
import AdminLayout from "@/components/AdminLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, ArrowLeft } from "lucide-react";

export default function Profile() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: user?.name || "", email: user?.email || "", phone: user?.phone || "", cidade: user?.cidade || "", estado: user?.estado || "" });
  const [pass, setPass] = useState({ current_password: "", new_password: "" });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const saveProfile = async (e) => {
    e.preventDefault();
    setSaving(true);
    try { const { data } = await api.put("/auth/profile", form); setUser({ ...user, ...data }); toast.success("Perfil atualizado!"); }
    catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  const savePass = async (e) => {
    e.preventDefault();
    setSaving(true);
    try { await api.put("/auth/profile", pass); setPass({ current_password: "", new_password: "" }); toast.success("Senha alterada!"); }
    catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <AdminLayout>
      <button onClick={() => navigate("/painel")} className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground mb-3 transition-colors" data-testid="perfil-voltar"><ArrowLeft className="w-4 h-4" /> Painel</button>
      <h1 className="font-display text-3xl sm:text-4xl font-black text-foreground mb-6">Meu perfil</h1>

      <div className="rounded-2xl border border-border bg-card p-6 mb-5">
        <h2 className="font-display text-lg font-bold text-primary mb-4">Dados da loja</h2>
        <form onSubmit={saveProfile} className="space-y-4 max-w-md">
          <div><Label className="text-muted-foreground">Nome / loja</Label><Input data-testid="profile-name" value={form.name} onChange={set("name")} className="mt-1.5 bg-card" style={{ height: 48 }} /></div>
          <div><Label className="text-muted-foreground">E-mail</Label><Input data-testid="profile-email" type="email" value={form.email} onChange={set("email")} className="mt-1.5 bg-card" style={{ height: 48 }} /></div>
          <div><Label className="text-muted-foreground">Telefone</Label><Input data-testid="profile-phone" value={form.phone} onChange={set("phone")} className="mt-1.5 bg-card" style={{ height: 48 }} /></div>
          <div className="grid grid-cols-3 gap-3">
            <div className="col-span-2"><Label className="text-muted-foreground">Cidade de atuação</Label><Input data-testid="profile-cidade" value={form.cidade} onChange={set("cidade")} placeholder="Ex: São Paulo" className="mt-1.5 bg-card" style={{ height: 48 }} /></div>
            <div><Label className="text-muted-foreground">Estado (UF)</Label><Input data-testid="profile-estado" value={form.estado} onChange={set("estado")} placeholder="SP" maxLength={2} className="mt-1.5 bg-card uppercase" style={{ height: 48 }} /></div>
          </div>
          <Button data-testid="save-profile-button" disabled={saving} className="rounded-full font-semibold" style={{ height: 48 }}>{saving ? <Loader2 className="w-5 h-5 animate-spin" /> : "Salvar dados"}</Button>
        </form>
      </div>

      <div className="rounded-2xl border border-border bg-card p-6">
        <h2 className="font-display text-lg font-bold text-primary mb-4">Alterar senha</h2>
        <form onSubmit={savePass} className="space-y-4 max-w-md">
          <div><Label className="text-muted-foreground">Senha atual</Label><Input data-testid="current-password" type="password" value={pass.current_password} onChange={(e) => setPass({ ...pass, current_password: e.target.value })} className="mt-1.5 bg-card" style={{ height: 48 }} required /></div>
          <div><Label className="text-muted-foreground">Nova senha</Label><Input data-testid="new-password" type="password" value={pass.new_password} onChange={(e) => setPass({ ...pass, new_password: e.target.value })} className="mt-1.5 bg-card" style={{ height: 48 }} required /></div>
          <Button data-testid="save-password-button" disabled={saving} className="rounded-full font-semibold" style={{ height: 48 }}>{saving ? <Loader2 className="w-5 h-5 animate-spin" /> : "Alterar senha"}</Button>
        </form>
      </div>
    </AdminLayout>
  );
}
